import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getErrorLogs(page, limit, search) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(this.env.url + `/logs/errors?page=${page}&limit=${limit}&search=${search}&code=` + this.env.key, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getErrorLog(ID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/logs/errors/${ID}?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  testErrorModal(type){
    // Type 1 - 4 available
    // 1 - string error
    // 2 - bad request
    // 3 - hubtiger exception
    // 4 - exception
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/logs/errors/test/modal?type=${type}&code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          // Add this for error feedback
          this.errorHandler.showError(res, 
            "Failed to perform or process the goal of the api");

          return throwError(res.json());
        }),
      );
  }
}
